module.exports = __webpack_public_path__ + "img/37580-117.23f79e8f.jpg";